import styled from "@emotion/styled";

export const FeedbackActions = styled.div`
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-right: 32px;
  margin-bottom: 32px;
`;
